import { render } from "./jtTopicCheck.vue?vue&type=template&id=17c40147&scoped=true"
import script from "./jtTopicCheck.vue?vue&type=script&lang=js"
export * from "./jtTopicCheck.vue?vue&type=script&lang=js"

import "./jtTopicCheck.vue?vue&type=style&index=0&id=17c40147&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c40147"]])

export default __exports__